export const FETCHED_DESTINATIONS = 'FETCHED_DESTINATIONS';
export const FETCHED_TRIP_FORMATS = 'FETCHED_TRIP_FORMATS';
export const FETCHED_TYPES_OF_WORK = 'FETCHED_TYPES_OF_WORK';
export const FETCHED_PAGES_TAGS = 'FETCHED_PAGES_TAGS';


// WEBPACK FOOTER //
// ./src/containers/taxonomy/types.js